import { createNavigation } from 'next-intl/navigation'
import { routing } from './routing'

/**
 * Link, redirect, usePathname, useRouter et getPathname localisés.
 * À utiliser partout : ils appliquent automatiquement les chemins traduits.
 */
export const { Link, redirect, usePathname, useRouter, getPathname } = createNavigation(routing)
